import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type AiChatConversationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type AiChatConversationQuery = {
  aiChatConversation?: {
    id?: string | null
    title?: string | null
    status: string
    totalInputTokens: number
    totalOutputTokens: number
    createdAt?: string | null
    updatedAt?: string | null
    messages: Array<{
      id?: string | null
      role: string
      content?: string | null
      status: string
      toolCalls: any
      usage: any
      viewContext: any
      createdAt?: string | null
      updatedAt?: string | null
      uploads: Array<{ attachmentFilename?: string | null; attachmentUrl?: string | null }>
    }>
  } | null
}

export const AiChatConversationDocument = gql`
  query aiChatConversation($id: ID!) {
    aiChatConversation(id: $id) {
      id
      title
      status
      totalInputTokens
      totalOutputTokens
      createdAt
      updatedAt
      messages {
        id
        role
        content
        status
        toolCalls
        usage
        viewContext
        createdAt
        updatedAt
        uploads {
          attachmentFilename
          attachmentUrl
        }
      }
    }
  }
`

/**
 * __useAiChatConversationQuery__
 *
 * To run a query within a React component, call `useAiChatConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiChatConversationQuery(
  baseOptions: Apollo.QueryHookOptions<AiChatConversationQuery, AiChatConversationQueryVariables> &
    ({ variables: AiChatConversationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AiChatConversationQuery, AiChatConversationQueryVariables>(
    AiChatConversationDocument,
    options
  )
}
export function useAiChatConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiChatConversationQuery,
    AiChatConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AiChatConversationQuery, AiChatConversationQueryVariables>(
    AiChatConversationDocument,
    options
  )
}
export function useAiChatConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiChatConversationQuery, AiChatConversationQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AiChatConversationQuery, AiChatConversationQueryVariables>(
    AiChatConversationDocument,
    options
  )
}
export type AiChatConversationQueryHookResult = ReturnType<typeof useAiChatConversationQuery>
export type AiChatConversationLazyQueryHookResult = ReturnType<
  typeof useAiChatConversationLazyQuery
>
export type AiChatConversationSuspenseQueryHookResult = ReturnType<
  typeof useAiChatConversationSuspenseQuery
>
export type AiChatConversationQueryResult = Apollo.QueryResult<
  AiChatConversationQuery,
  AiChatConversationQueryVariables
>
